import { flagg } from "@intelligems/ig-vendors/flagg/core/core";
import { localStore } from "@intelligems/ig-vendors/flagg/store/local-store";

export const definitions = {
  aiQa: {
    default: false,
    description: "Enable AI QA in the Experiment Preview tab",
  },
  adminModularPhasesDrawer: {
    default: true,
    description:
      "Show and schedule the modular upcoming phase in the admin subscription drawer",
  },
  billingSettings2026DynamicSubheader: {
    default: false,
    description: "Dynamic subheader with provider link in Billing Settings",
  },
};

export const featureFlags = flagg({
  store: localStore(),
  definitions,
});
